// extracted by mini-css-extract-plugin
export default {"centerAlignText":"ni79uaRjKX0jUvTUh1L9"};